var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"state-devicetype-table elevation-0",attrs:{"dense":"","disable-sort":"","hide-default-footer":"","headers":_vm.headers,"items":_vm.itemsCalculated},scopedSlots:_vm._u([{key:"item.total",fn:function(ref){
var item = ref.item;
return [_c('strong',[_vm._v(_vm._s(item.total))])]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('span',{class:_vm.getCssClassFromState(item.name)},[_vm._v(_vm._s(_vm.getCorrectStateName(item.name)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }